export default __webpack_public_path__ + "f5cee5e0b1283dc0c5e459af69987c71.png";